import { extractStringValueSet } from './extract-properties';

/**
 * Lists of order status options
 */
export default class OrderStatus {

    /**
   * @deprecated Use Open instead
   */
    static readonly OPEN: string = 'open';
    /**
      * @deprecated Use Complete instead
      */
    static readonly COMPLETE: string = 'complete';
    /**
      * @deprecated Use Canceled instead
      */
    static readonly CANCELED: string = 'canceled';
    /**
      * @deprecated It's not supported
      */
    static readonly ON_HOLD: string = 'on-hold';

    static readonly Open: string = 'open';
    static readonly Complete: string = 'complete';
    static readonly Canceled: string = 'canceled';

    private static _valueSet: Set<string> = null;
    static get values(): Set<string> {

        if (!this._valueSet) {
            this._valueSet = new Set();
            this._valueSet = extractStringValueSet(this);
        }

        return new Set(this._valueSet);
    }
}
